<form class="flex flex-col space-y-5" [formGroup]="form">
    <app-page-header-nav
        title="Review User"
        [navItems]="pageHeaderNavItems"
    ></app-page-header-nav>
    <div class="flex flex-col px-5 space-y-4">
        <section class="grid grid-cols-2 max-w-4xl">
            <div class="flex flex-col">
                <p class="font-medium">Username:</p>
                <p class="text-sm">{{ user.username }}</p>
            </div>

            <div class="flex flex-col">
                <p class="font-medium">Company Address:</p>
                <p class="text-sm">
                    {{ user.streetAddress }}, {{ user.city }},
                    {{ user.stateProvince?.name }} {{ user.postalCode }}
                </p>
            </div>

            <div class="flex flex-col">
                <p class="font-medium">Name:</p>
                <p class="text-sm">{{ user.fullName }}</p>
            </div>

            <div class="flex flex-col">
                <p class="font-medium">Direct Phone Number:</p>
                <p class="text-sm" mask="(000) 000-0000 ext. 99999">
                    {{ user.phoneNumber ?? 'N/A' }}
                </p>
            </div>

            <div class="flex flex-col">
                <p class="font-medium">Email:</p>
                <p class="text-sm">{{ user.email }}</p>
            </div>

            <div class="flex flex-col">
                <p class="font-medium">Status:</p>
                <p class="text-sm">{{ user.status }}</p>
            </div>
        </section>

        <section class="flex flex-col max-w-md">
            <app-organization-search
                [originalOrganizationName]="originalOrganizationName"
                (organizationMatchChange)="onOrganizationMatchChange($event)"
                formControlName="organizationName"
            ></app-organization-search>

            @if (!this.organizationMatch) {
                <section class="flex flex-col">
                    <p class="font-medium !m-0">Company/Organization Type:</p>
                    <mat-form-field appearance="outline" class="w-full pt-2">
                        <mat-label>Company type</mat-label>
                        <mat-select formControlName="organizationType">
                            @for (
                                organizationType of organizationTypes;
                                track organizationType.value
                            ) {
                                <mat-option [value]="organizationType.value">
                                    {{ organizationType.description }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (showOrganizationTypeOtherField()) {
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>If Other Please Specify</mat-label>
                            <input
                                title="Company type (other)"
                                matInput
                                minlength="3"
                                maxlength="50"
                                [pattern]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                formControlName="otherOrganizationType"
                            />
                        </mat-form-field>
                    }
                </section>
            }
            <p class="font-medium">Assign a Role:</p>
            <mat-form-field appearance="outline" class="w-full">
                <mat-select formControlName="role">
                    @for (userRole of userRoles; track userRole) {
                        <mat-option [value]="userRole">{{
                            UserRoleLabelMapping[userRole]
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </section>
    </div>
</form>
